import { INavItem } from "@webapp/navigation/models/nav-items-list.models";
import { ICollection } from "@gtmhub/models";
import { UXCustomizationType } from "@gtmhub/uxcustomization/models";
import { IFavoriteItemsGroupedReqParams, IFavoritesChange } from "@gtmhub/favorites/models";
import { RequestPaging } from "@webapp/core/abstracts/models/request.paging";

export class FavoritesFactory {
  public buildNavigationFavoritesRequestPaging(types: UXCustomizationType[]): RequestPaging {
    const requestPaging: RequestPaging = {
      ...new RequestPaging(),
      filter: {
        type: {
          $in: types,
        },
      },
    };
    return requestPaging;
  }

  public buildNavigationFavoritesRequestParams(types: UXCustomizationType[]): IFavoriteItemsGroupedReqParams {
    return {
      filter: {
        type: {
          $in: types,
        },
      },
    };
  }

  public buildFavoritesChangeHandler(types: UXCustomizationType[]): (changeEvent: IFavoritesChange, favorites: ICollection<INavItem>) => ICollection<INavItem> {
    return (changeEvent: IFavoritesChange, favorites: ICollection<INavItem>) => {
      if (types.indexOf(changeEvent.type) !== -1) {
        switch (changeEvent.eventType) {
          case "UPDATE":
          case "CREATE":
            {
              if (favorites.items.find((item) => item.id === changeEvent.item.id)) {
                favorites.items = favorites.items.filter((item) => item.id !== changeEvent.item.id);
              } else {
                favorites.totalCount++;
                favorites.count++;
              }
              favorites.items = [changeEvent.item, ...favorites.items];
            }
            break;
          case "DELETE":
            {
              if (favorites.items.find((item) => item.favoriteId === changeEvent.item.favoriteId)) {
                favorites.items = favorites.items.filter((item) => item.favoriteId !== changeEvent.item.favoriteId);
                favorites.totalCount--;
                favorites.count--;
              }
            }
            break;
        }
      }
      return favorites;
    };
  }
}
